import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface QuoteStatusEntry {
  id?: ID
  status: string
  message?: string
  gf?: string
  created?: string
}

export interface QuoteStatusData {
  quote: QuoteStatusEntry
}

export interface QuoteStatusVariables {
  id: ID
  accessKey?: string
}

export const QUOTE_STATUS_QUERY = gql`
  query status($id: ID!, $accessKey: String) {
    quote: getQuoteById(id: $id, accessKey: $accessKey) {
      id
      status
      message
      gf
      created
    }
  }
`
